import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: row;
  background-color: #d7fffc;
  width: 100vw;
`;
